<template>
  <div>
    <v-row
      dense
      class="mt-4"
    >
      <v-col
        cols="auto"
        class="pl-3 my-auto"
      >
        <v-img
          :src="snailblastLogo"
          contain
          max-width="90"
        />
      </v-col>
      <v-col cols="auto"> | </v-col>
      <v-col cols="auto"> Easily print & mail postcards anywhere </v-col>
      <v-col
        cols="12"
        class="mt-1"
      >
        <ul>
          <li
            v-for="item in bullets"
            :key="item"
          >
            {{ item }}
          </li>
        </ul>
      </v-col>
    </v-row>
    <v-row>
      <v-col
        v-if="!audience_selected"
        cols="12"
      >
        <v-text-field
          v-model="quantity"
          label="Quantity"
          hide-details="auto"
          outlined
          :rules="[minQuantity]"
          @change="getPrice"
        >
          <template #label>
            <mcs-input-label
              label="Quantity"
              :information="
                quantity
                  ? `<p>
                      This estimated quantity helps you preview the price before adding your
                      audience. It represents the number of postcards you need, or in other words,
                      the number of people you want to reach.
                    </p>
                    <p>
                      This value will be replaced with the actual audience size once your audience
                      is added.
                    </p>`
                  : ''
              "
            />
          </template>
        </v-text-field>
      </v-col>
      <v-col cols="12">
        <mcs-date-picker
          ref="mailboxDate"
          v-model="edit_item.delivery.earliestDate"
          :rules="[$rules.required, lessThanMin]"
          label="In Mailbox Date"
          :min="min"
          :max="max"
          :show-current="min"
          use-schedule-range
          @change="changeMailboxDate"
        >
          <template #label>
            <mcs-input-label
              label="In Mailbox Date"
              information="<p>
                      The in-mailbox date marks when your postcards are expected to arrive in your
                      recipients' mailboxes. Although USPS is responsible for final delivery and
                      doesn't guarantee precise dates, our team is focused on quickly preparing and
                      sending your postcards to ensure timely delivery.
                    </p>"
            />
          </template>
        </mcs-date-picker>
      </v-col>
      <template v-if="isMissionPrint && (is_list_purchase || is_upload)">
        <v-col cols="12">
          <v-select
            v-model="edit_item.postageOptionName"
            :rules="[$rules.required]"
            label="Postage Options"
            outlined
            hide-details="auto"
            item-value="name"
            item-text="display"
            :items="postage_options"
            @change="getPrice(campaign.recipientCount || quantity)"
          >
            <template #label>
              <!-- <mcs-input-label
              label="In Mailbox Date"
              information="<p>
                      The in-mailbox date marks when your postcards are expected to arrive in your
                      recipients' mailboxes. Although USPS is responsible for final delivery and
                      doesn't guarantee precise dates, our team is focused on quickly preparing and
                      sending your postcards to ensure timely delivery.
                    </p>"
            /> -->
            </template>
          </v-select>
        </v-col>
        <v-col
          v-if="edit_item.postageOptionName == 'Non Profit'"
          cols="12"
        >
          <v-text-field
            v-model="edit_item.customerCrid"
            outlined
            label="USPS® Customer Registration ID"
            placeholder="USPS® Customer Registration ID"
            persistent-placeholder
            maxlength="15"
            hide-details="auto"
            class="white"
            :rules="[$rules.required]"
            @keypress="isNumber($event)"
          >
            <!-- <template #label>
              <mcs-input-label
              label="USPS® Customer Registration ID"
              information="<p>
                      The in-mailbox date marks when your postcards are expected to arrive in your
                      recipients' mailboxes. Although USPS is responsible for final delivery and
                      doesn't guarantee precise dates, our team is focused on quickly preparing and
                      sending your postcards to ensure timely delivery.
                    </p>"
            />
            </template> -->
          </v-text-field>
        </v-col>
      </template>
      <v-col cols="12">
        <mcs-card :title="title">
          <template #title-append>
            <mcs-btn
              v-if="audience_selected"
              color="black"
              text
              class="pa-0"
              @click="resetAudience"
            >
              Reset
            </mcs-btn>
            <mcs-btn
              v-if="audience_selected || previous_campaigns.length"
              color="primary"
              text
              class="pa-0"
              @click="showAudience(!audience_selected)"
            >
              {{ audience_selected ? 'Edit' : previousText }}
            </mcs-btn>
          </template>
          <div>
            <template v-if="audience_items.length">
              <v-row
                v-for="(item, i) in audience_items"
                :key="i"
                dense
              >
                <v-col cols="auto">
                  <v-icon
                    :color="item.iconColor"
                    x-small
                  >
                    {{ item.icon }}
                  </v-icon>
                </v-col>
                <v-col>
                  {{ item.label }}
                  <span
                    :class="[
                      'text-decoration-underline',
                      item.showMailboxDate ? 'hover-pointer' : ''
                    ]"
                    @click="item.showMailboxDate ? showMailboxDate() : undefined"
                  >
                    {{ item.text }}
                  </span>
                </v-col>
              </v-row>
              <mcs-sheet
                v-if="showMaps"
                no-padding
                outlined
                class="mt-4 overflow-hidden"
              >
                <RoutesMap
                  v-if="is_eddm"
                  id="previewMap"
                  height="150px"
                  readonly
                />
                <ListPurchaseMap
                  v-if="is_list_purchase"
                  id="previewListPurchaseMap"
                  height="150px"
                  readonly
                />
                <div
                  v-if="is_upload"
                  class="pa-4 hover-pointer"
                  @click="showAudience(false)"
                >
                  <v-icon
                    small
                    class="mr-2"
                  >
                    mdi-file-document
                  </v-icon>
                  <span>{{ campaign.addressFileName }}</span>
                </div>
              </mcs-sheet>
            </template>
          </div>

          <template #actions>
            <mcs-btn
              v-if="!audience_items.length"
              block
              outlined
              large
              color="black"
              prepend-icon="mdi-plus-circle"
              @click="showAudience(false)"
            >
              {{ buttonText }}
            </mcs-btn>
          </template>
        </mcs-card>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import ListPurchaseMap from '@/components/print/checkout/snailblast/listpurchase/Map';
import RoutesMap from '@/components/print/checkout/snailblast/routes/Map';
import { ANALYTICS_EVENTS, APP_EVENTS, DRAWERS } from '@/utils/constants';
import snailblast from '@/utils/mixins/snailblast';
import moment from 'moment';
import { mapGetters } from 'vuex';
export default {
  name: 'EditItemSnailblast',
  components: { RoutesMap, ListPurchaseMap },
  mixins: [snailblast],
  props: { mailingOption: { type: Object, default: () => {} } },
  data: () => ({
    loading: false,
    date_menu: false,
    quantity: 200
  }),
  computed: {
    title() {
      return this.is_upload ? 'Mailing List' : 'Audience Size';
    },
    previousText() {
      return this.is_upload ? 'Previous list >' : 'Previous audience >';
    },
    buttonText() {
      return this.is_upload ? 'Add List' : 'Add Audience';
    },
    snailblastLogo() {
      return this.$store.state.config.snailblastLogo;
    },
    bullets() {
      if (this.is_eddm) {
        return [
          'Target one or more areas/routes on a map',
          'Target residential or residential + businesses',
          "We'll save your audience for future use",
          '16 Pt Cardstock Premium (High Gloss UV Front Only)',
          'Print, postage & mailing included'
        ];
      }
      if (this.is_list_purchase) {
        return [
          'Target one or more areas on a map',
          'Filter by 1000s of demographic details',
          'Reach individuals and businesses',
          "We'll save your list for future use",
          'Premium 16 Pt Cardstock (High Gloss UV Front Only)',
          'Print, postage & mailing included'
        ];
      }
      if (this.is_upload) {
        return [
          'Upload and mail to a list of addresses',
          'Merge duplicates & fix errors',
          "We'll save your list for future use",
          'Premium 16 Pt Cardstock (High Gloss UV Front Only)',
          'Print, postage & mailing included'
        ];
      }
      return [];
    },
    audience_selected() {
      return this.campaign && this.campaign.recipientCount;
    },
    audience_items() {
      if (!this.audience_selected) {
        return [];
      }

      let addressText = this.$options.filters.separator(this.campaign.recipientCount);
      let addressIcon = 'mdi-check-circle';
      let addressColor = 'green';
      if (!this.addresses_valid) {
        if (!!this.maximum && this.address_count > this.maximum) {
          addressText += ` (Max ${this.maximum})`;
          addressIcon = 'mdi-close-circle';
          addressColor = 'error';
        } else if (!!this.minimum && this.address_count < this.minimum) {
          addressText += ` (Min ${this.minimum})`;
          addressIcon = 'mdi-close-circle';
          addressColor = 'error';
        }
      }

      return [
        {
          label: 'Addresses',
          text: addressText,
          icon: addressIcon,
          iconColor: addressColor
        },
        {
          label: 'Expected In-Mailboxes',
          text: this.formattedScheduledDate || 'Not set',
          icon: this.dateValid ? 'mdi-check-circle' : 'mdi-close-circle',
          iconColor: this.dateValid ? 'green' : 'error',
          showMailboxDate: !!this.formattedScheduledDate
        }
      ];
    },
    min() {
      const date = moment(this.mailbox_date);
      return date.format('YYYY-MM-DD');
    },
    max() {
      return moment(this.min).add(90, 'days').format('YYYY-MM-DD');
    },
    formattedScheduledDate() {
      const date = this.edit_item.delivery?.earliestDate;
      if (!date) {
        return '';
      }
      return this.getScheduleRangeFormatted(date);
    },
    edit_item: {
      get() {
        return this.$store.getters['printcart/edit_item'];
      },
      set(val) {
        this.$store.dispatch('printcart/setEditItem', val);
      }
    },
    campaign: {
      get() {
        return this.$store.getters['printcart/campaign'];
      },
      set(val) {
        this.$store.dispatch('printcart/setCampaign', val);
      }
    },
    dateValid() {
      return moment(this.edit_item.delivery.earliestDate) >= moment(this.min);
    },
    showMaps() {
      return this.top_drawer.id === DRAWERS.PRINT_CHECKOUT;
    },
    ...mapGetters({
      previous_campaigns: 'snailblast/campaign/previous',
      mailbox_date: 'snailblast/campaign/mailbox_date',
      is_eddm: 'snailblast/campaign/is_eddm',
      is_upload: 'snailblast/campaign/is_upload',
      is_list_purchase: 'snailblast/campaign/is_list_purchase',
      campaign_routes: 'snailblast/campaign/routes',
      top_drawer: 'drawers/topDrawer',
      analytics_data: 'snailblast/campaign/analytics_data',
      authorized: 'user/authorized',
      address_count: 'snailblast/campaign/address_count',
      minimum: 'snailblast/campaign/addresses_minimum',
      maximum: 'snailblast/campaign/addresses_maximum',
      addresses_valid: 'snailblast/campaign/addresses_valid',
      isMissionPrint: 'user/isMissionPrint',
      postage_options: 'printcart/postage_options'
    })
  },
  watch: {
    campaign(val, oldVal) {
      if (val) {
        if (val.id !== oldVal.id && val.recipientCount) {
          this.loadData();
        } else if (val.typeId !== oldVal?.typeId) {
          this.getMailboxDate();
        }
      }
    }
  },
  mounted() {
    this.loadData();
  },
  methods: {
    loadData() {
      if (!this.campaign?.typeId) {
        return;
      }
      this.loading = true;
      const calls = [
        this.$store.dispatch('snailblast/lookup/get'),
        this.$store.dispatch('snailblast/campaign/setWithExtraData', this.campaign),
        this.$store.dispatch('snailblast/campaign/getMailboxDate', this.campaign.typeId)
      ];
      if (this.authorized) {
        calls.push(
          this.$store.dispatch('snailblast/campaign/getPreviousCampaigns', this.campaign.typeId)
        );
      }
      Promise.all(calls)
        .then(() => {
          this.$store.dispatch('snailblast/routes/setRoutes', this.campaign_routes);
          this.$store.dispatch('snailblast/routes/selectRoutesFromTable', this.campaign_routes);
          this.$nextTick(() => {
            this.getPrice(this.campaign.recipientCount || this.quantity);
          });
        })
        .catch((error) => {
          this.logError(error, 'Error getting campaign information');
        })
        .finally(() => {
          this.loading = false;
        });
    },
    getMailboxDate() {
      this.loading = true;
      Promise.all([
        this.$store.dispatch('snailblast/campaign/getMailboxDate', this.campaign.typeId),
        this.$store.dispatch('snailblast/campaign/getPreviousCampaigns', this.campaign.typeId)
      ])
        .catch((error) => {
          this.logError(error, 'Error getting mailbox date');
        })
        .finally(() => {
          this.loading = false;
        });
    },
    showAudience(previous) {
      this.$store.dispatch('drawers/open', {
        drawerId: DRAWERS.SNAILBLAST_AUDIENCE,
        data: { previous }
      });
    },
    resetAudience() {
      this.loading = true;
      this.$store
        .dispatch('printcart/setCampaign', {
          typeId: this.campaign.typeId
        })
        .finally(() => {
          this.loading = false;
        });
    },
    getPrice(val) {
      this.$nextTick(() => {
        this.$eventBus.$emit(APP_EVENTS.GET_EDIT_ITEM_PRICE, {
          qtyOverride: val,
          source: 'snailblast'
        });
      });
    },
    lessThanMin(v) {
      return this.dateValid || `Must be on or after ${this.$options.filters.normalDate(this.min)}`;
    },
    changeMailboxDate(val) {
      this.$mixpanel.trackEvent(
        ANALYTICS_EVENTS.MAILING_SERVICE.NAME,
        null,
        Object.assign(this.analytics_data, { mailbox_date: val })
      );
    },
    showMailboxDate() {
      this.$refs.mailboxDate.show();
    },
    minQuantity() {
      let min = 0;
      if (this.mailingOption && this.mailingOption.minimum) {
        min = this.mailingOption.minimum;
      }
      return this.quantity >= min || `Minimum of ${min}`;
    },
    isNumber(e) {
      const char = String.fromCharCode(e.keyCode);
      if (/^[0-9]+$/.test(char)) return true;
      else e.preventDefault();
    }
  }
};
</script>
